import UploadFile from './uploadfile'
export default UploadFile